<template>
  <el-select
    v-model="v"
    placeholder='签约类型'
    clearable
    :size="size"
    :multiple="multiple"
    :collapse-tags="collapseTags">
    <el-option v-for='(item,key) in MapSignType' :key='key' :label='item.label' :value='key' />
  </el-select>
</template>

<script>
import { MapSignType } from '../../enum/sign-info'

export default {
  name: 'SelectSignType',
  computed: {
    MapSignType() {
      return MapSignType
    }
  },
  props: {
    // eslint-disable-next-line vue/require-prop-types
    value: {
      default: null
    },
    size: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    collapseTags: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      v: this.multiple ? [] : null
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(_) {
        this.v = this.normalizeValue(_)
      }
    },
    multiple() {
      this.v = this.normalizeValue(this.value)
    },
    v(_) {
      this.$emit('update:label', _)
      this.$emit('update:value', _)
      this.$nextTick(() => {
        this.$emit('change')
      })
    }
  },
  methods: {
    normalizeValue(value) {
      if (this.multiple) {
        if (Array.isArray(value)) return value
        return value ? [value] : []
      }
      if (Array.isArray(value)) return value[0] || null
      return value
    }
  }
}
</script>
<style scoped>

</style>
